import { PAGES } from '@/constants/page';

const Home = () => import(/* webpackChunkName: 'home' */ '@/views/Home.vue');
const Detail = () =>
  import(/* webpackChunkName: 'detail' */ '@/views/Detail.vue');
const Error404 = () =>
  import(/* webpackChunkName: 'error404' */ '@/views/Error404.vue');

const routes = [
  {
    name: 'home',
    path: '/',
    component: Home,
    meta: {
      title: PAGES.home.title
    }
  },
  {
    name: 'detail',
    path: '/detail/',
    component: Detail,
    meta: {
      title: PAGES.detail.title
    }
  },
  {
    name: '404',
    path: '*',
    component: Error404,
    meta: {
      title: PAGES.Error404.title,
      title_en: PAGES.Error404.title_en
    }
  }
];

export default routes;
